import React from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const leadForm = ({formData, onInputChange, onSelectChange, assigneeName}) => {
  const handleLeadSubmit = (event) => {
    event.preventDefault()
  }
  return (
    <form onSubmit={handleLeadSubmit}>
      <div
        className='form-grid'
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 2fr',
          rowGap: '10px', // Reduce vertical spacing
          columnGap: '10px',
          alignItems: 'center',
        }}
      >
        {/* Type Selection */}
        <label className='form-label required'>Type</label>
        <select
          name='type'
          className='form-select form-select-solid'
          value={formData.type}
          onChange={onInputChange}
          required
        >
          <option value='' disabled>
            Select Type
          </option>
          <option value='company'>Company</option>
          <option value='singleUser'>Single User</option>
        </select>

        {/* Name */}
        <label className='form-label required'>Name</label>
        <input
          type='text'
          name='name'
          className='form-control'
          placeholder='Enter Name'
          value={formData.name}
          onChange={onInputChange}
          required
        />

        {/* Phone */}
        <label className='form-label required'>Phone</label>
        <PhoneInput
          country={'us'} // Default country code
          value={formData.phone}
          onChange={(phone) => onInputChange({target: {name: 'phone', value: phone}})}
          inputClass='form-control'
          placeholder='Enter Phone Number'
          inputStyle={{
            width: '100%', 
            height: '42px',
            borderRadius: '4px', 
            border: '1px solid #ced4da',
          }}
        />

        {/* Email */}
        <label className='form-label required'>Email</label>
        <input
          type='email'
          name='email'
          className='form-control'
          placeholder='Enter Email'
          value={formData.email}
          onChange={onInputChange}
          required
        />

        {/* Assignee */}
        <label className='form-label required' htmlFor='assigneeSelect'>
          Assignee
        </label>
        <select
          id='assigneeSelect'
          className='form-select form-select-solid'
          value={formData.assignee_id || ''}
          name='assignee_id'
          onChange={(e) => {
            const selectedAssignee = assigneeName.find(
              (assignee) => assignee.id === parseInt(e.target.value)
            )
            if (selectedAssignee) {
              onSelectChange('assignee_id', selectedAssignee.id) // Send ID
              onSelectChange('assignee_name', selectedAssignee.name) // Store Name (if needed)
            }
          }}
        >
          <option value='' disabled>
            Select Assignee
          </option>
          {assigneeName?.map((assignee) => (
            <option key={assignee.id} value={assignee.id}>
              {assignee.name}
            </option>
          ))}
        </select>
      </div>
      {/* Horizontal Line */}
      <hr style={{margin: '20px 0', border: '1px solid #ddd'}} />

      <div
        style={{display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '20px', alignItems: 'center'}}
      >
        <label className='form-label'>Comment</label>
        <textarea
          name='comment'
          className='form-control'
          placeholder='Enter Comment'
          value={formData.comment}
          onChange={onInputChange}
        ></textarea>
      </div>
    </form>
  )
}

export default leadForm
